/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.temp.checkHandleAvailability'

export { $nsid }

/** Checks whether the provided handle is available. If the handle is not available, available suggestions will be returned. Optional inputs will be used to generate suggestions. */
const main = l.query(
  $nsid,
  l.params({
    handle: l.string({ format: 'handle' }),
    email: l.optional(l.string()),
    birthDate: l.optional(l.string({ format: 'datetime' })),
  }),
  l.jsonPayload({
    handle: l.string({ format: 'handle' }),
    result: l.typedUnion(
      [
        l.typedRef<ResultAvailable>((() => resultAvailable) as any),
        l.typedRef<ResultUnavailable>((() => resultUnavailable) as any),
      ],
      false,
    ),
  }),
  ['InvalidEmail'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

/** Indicates the provided handle is available. */
type ResultAvailable = {
  $type?: 'com.atproto.temp.checkHandleAvailability#resultAvailable'
}

export type { ResultAvailable }

/** Indicates the provided handle is available. */
const resultAvailable = l.typedObject<ResultAvailable>(
  $nsid,
  'resultAvailable',
  l.object({}),
)

export { resultAvailable }

/** Indicates the provided handle is unavailable and gives suggestions of available handles. */
type ResultUnavailable = {
  $type?: 'com.atproto.temp.checkHandleAvailability#resultUnavailable'

  /**
   * List of suggested handles based on the provided inputs.
   */
  suggestions: Suggestion[]
}

export type { ResultUnavailable }

/** Indicates the provided handle is unavailable and gives suggestions of available handles. */
const resultUnavailable = l.typedObject<ResultUnavailable>(
  $nsid,
  'resultUnavailable',
  l.object({
    suggestions: l.array(l.ref<Suggestion>((() => suggestion) as any)),
  }),
)

export { resultUnavailable }

type Suggestion = {
  $type?: 'com.atproto.temp.checkHandleAvailability#suggestion'
  handle: l.HandleString

  /**
   * Method used to build this suggestion. Should be considered opaque to clients. Can be used for metrics.
   */
  method: string
}

export type { Suggestion }

const suggestion = l.typedObject<Suggestion>(
  $nsid,
  'suggestion',
  l.object({ handle: l.string({ format: 'handle' }), method: l.string() }),
)

export { suggestion }
